import getFieldIdsByKey from './get-field-ids-by-key';
import generateFieldKey from './generate-field-key';
import setupSteps from '../constants/setup-steps';
import fieldNames from '../constants/field-names';
import fieldTypes from '../constants/field-types';
import { OTHER_VALUE, newWebsitePreparedContentValues } from '../constants/fields-values';
import { OTHER_FIELDS_ID } from '../constants/field-ids';

const extractFieldData = ({ field: { id, type, name }, values }) => {
  const fieldValue = values[name];
  const value = type === fieldTypes.CHECKBOX ? fieldValue.join(', ') : fieldValue.trim();

  return { id, name, value };
};

const collectAndTransformFieldsData = ({ data, key, fields, values }) => {
  getFieldIdsByKey(key)
    .filter((id) => !OTHER_FIELDS_ID.includes(id))
    .forEach((fieldId) => {
      const field = fields.find(({ id }) => id === fieldId);
      const fieldData = extractFieldData({ field, values });

      if (field.name === fieldNames.NEW_WEBSITE_CONTENT) {
        fieldData.value = fieldData.value === newWebsitePreparedContentValues.YES;
      }

      data.push(fieldData);
    });
};

const prepareData = (values, fields) => {
  let data = [];

  collectAndTransformFieldsData({
    data,
    key: generateFieldKey(setupSteps.PROJECT),
    fields,
    values,
  });
  collectAndTransformFieldsData({
    data,
    key: generateFieldKey(setupSteps.DETAILS, values[fieldNames.SERVICE]),
    fields,
    values,
  });
  collectAndTransformFieldsData({
    data,
    key: generateFieldKey(setupSteps.CONTACT_INFO),
    fields,
    values,
  });

  OTHER_FIELDS_ID.forEach((fieldId) => {
    const field = fields.find(({ id }) => id === fieldId);
    const otherData = extractFieldData({ field, values });

    data = data.map((item) => {
      if (item.id !== field.parentId) return item;

      let itemValue = item.value;

      if (otherData.value) {
        itemValue = itemValue.replace(OTHER_VALUE, otherData.value);
      } else {
        itemValue = itemValue
          .split(', ')
          .filter((value) => value !== OTHER_VALUE)
          .join(', ');
      }

      return {
        ...item,
        value: itemValue,
      };
    });
  });

  return data
    .filter(({ value }) => (typeof value === 'boolean' ? true : Boolean(value)))
    .reduce((acc, { name, value }) => ({ ...acc, [name]: value }), {});
};

export default prepareData;
